<template>
    <m-filter text="Billing Code" :popup.sync="popup" :filtered="filtered">
        <m-lookup :data="mapValues" @select="select"></m-lookup>
    </m-filter>
</template>

<script>export default {
    props: {
        value: Object
    },
    data: () => ({
        billingCode: window.initial.products,
        popup: false
    }),
    methods: {
        select(s) {
            this.$emit('input', s)
            this.popup = false
        }
    },
    computed: {
        //Table header filter display
        filtered() {
            if (!this.value) {
                return ''
            }
            return this.value.code
        },
        mapValues() {
            return this.billingCode.map(item => ({
                value: item.code,
                id: item.id,
                code: item.code,
            }))
        }
    }
}</script>

